export default __webpack_public_path__ + "static/media/side.6ebe7f71.jpeg";